// Utils
import { component } from 'picoapp';

import choozy from 'utils/choozy';

export default component((node, ctx) => {
  const { select, optionInput = [] } = choozy(node);

  const optionInputs = [].concat(optionInput);

  const { formId, productId } = node.dataset;

  const handleChange = (e) => {
    e.stopPropagation();

    if (select.value.length === 0) return;

    select.value.split(',').forEach((value, index) => {
      optionInputs[index].value = value;
    });

    node.dispatchEvent(
      new CustomEvent(`${productId}:${formId}:variant-change`, { bubbles: true, cancelable: true }),
    );
  };

  const handleUpdate = (e) => {
    const { currentProductId } = e.detail;
    const { forms } = ctx.getState();
    const { selectedVariant } = forms[currentProductId];

    selectedVariant.options.forEach((value, index) => {
      optionInputs[index].value = value;
    });

    select.value = selectedVariant.options.join(',');
  };

  select.addEventListener('change', handleChange);

  document.addEventListener(`${productId}:${formId}:update`, handleUpdate);

  document.addEventListener(
    `${productId}:${formId}:unmount`,
    () => {
      document.removeEventListener(`${productId}:${formId}:update`, handleUpdate);
    },
    { once: true },
  );
});
